import { Route, Routes } from "react-router-dom";
import { ReduxRouter } from "@lagunovsky/redux-react-router";
import h from "@macrostrat/hyper";
import { Suspense } from "react";
import loadable from "@loadable/component";
import { Spinner } from "@blueprintjs/core";
import "./styles/index.styl";
import { Provider } from "react-redux";
import { createStore, compose, applyMiddleware } from "redux";
import reducerStack, { browserHistory } from "./map-interface/app-state";
import { createRouterMiddleware } from "@lagunovsky/redux-react-router";
import { routerBasename } from "./map-interface/settings";
import { DarkModeProvider } from "@macrostrat/ui-components";
var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
var routerMiddleware = createRouterMiddleware(browserHistory); // Create the data store

var store = createStore(reducerStack, composeEnhancers(applyMiddleware(routerMiddleware))); //const _ColumnPage = loadable(import("./columns"));
//const ColumnPage = () => h(Suspense, { fallback: h(Spinner) }, h(_ColumnPage));

/*
const _GlobeDevPage = loadable(() =>
  import("./map-page/cesium-view").then((d) => d.GlobeDevPage)
);

const GlobeDevPage = () =>
  h(Suspense, { fallback: h(Spinner) }, h(_GlobeDevPage));

function GlobePage() {
  return h(MapPage, { backend: MapBackend.CESIUM });
}
*/

var _Sources = loadable(function () {
  return import("~/burwell-sources");
});

var Sources = function Sources() {
  return h(Suspense, {
    fallback: h(Spinner)
  }, h(_Sources));
};

var _MapPage = loadable(function () {
  return import("./map-interface/map-page");
});

var MapPage = function MapPage() {
  return h(Suspense, {
    fallback: h(Spinner)
  }, h(_MapPage));
};

var App = function App() {
  return h(DarkModeProvider, h(Provider, {
    store: store
  }, h(ReduxRouter, {
    basename: routerBasename,
    store: store,
    history: browserHistory
  }, [h(Routes, [h(Route, {
    path: "/sources",
    element: h(Sources)
  }), h(Route, {
    path: "*",
    element: h(MapPage)
  })]) // h(Route, {
  //   path: "/globe",
  //   component: GlobePage,
  // }),
  // h(Route, { path: "/columns", component: ColumnPage }),
  //h(Route, { path: "/dev/globe", component: GlobeDevPage }),
  // h(Route, {
  //   exact: true,
  //   path: "/",
  //   render: () => h(Redirect, { to: "/map" }),
  // }),
  ])));
};

export default App;